import { ExternalLinkIcon } from '@icons/ExternalLinkIcon';
import { Badge } from '@ui/badge';
import { useTranslation } from '@hooks/useTranslation';

// Front's deep link that opens a conversation in the web/desktop app.
const FRONT_OPEN_URL = 'https://app.frontapp.com/open';

interface FrontEmailLinkProps {
  conversationId?: string | null;
}

// Links back to the Front email thread the order was drafted from, as the same
// plum Front badge the history log uses. Renders nothing when the order has no
// associated conversation.
export function FrontEmailLink({ conversationId }: FrontEmailLinkProps) {
  const { t } = useTranslation();

  if (!conversationId) return null;

  return (
    <a
      href={`${FRONT_OPEN_URL}/${encodeURIComponent(conversationId)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('front_email.label')}
      className="inline-flex shrink-0 rounded-xs"
    >
      <Badge
        variant="status"
        tone="plum"
        size="sm"
        bordered
        className="hover:border-plum"
      >
        {t('front_email.chip')}
        <ExternalLinkIcon className="size-3" />
      </Badge>
    </a>
  );
}
